module.exports = __webpack_public_path__ + "img/light-sm.a8e8140f.png";